import React, { Component } from 'react';
import classNames from 'classnames';
import { Button, Input, Combobox } from '@salesforce/design-system-react';

import BrowserContainer from '../../containers/browserContainer';
import { EMAIL_BANNER, CONFERENCE_NAME, DISCOUNT_CODE } from '../../constants';

class FormScreen extends Component {
  constructor(props) {
    super(props);
    this.discountField = React.createRef();
    this.state = {
      hasDiscountError: false,
      discountValue: '',
      ticketTypeValue: '',
      ticketTypeSelection: []
    };
  }

  componentDidMount() {
    this.discountField.current.focus();
  }

  handleDiscountOnChange = (event) => {
    const targetValue = event.target.value; 
    if(targetValue !== '') {
      if(targetValue.toLowerCase() === DISCOUNT_CODE) {
        this.setState((prevState, props) => ({
          hasDiscountError: false
        }));
      } else {
        this.setState((prevState, props) => ({
          hasDiscountError: true
        }));
      }
    } else {
        console.log(targetValue);
        this.setState((prevState, props) => ({
          hasDiscountError: false
        }));
    }

    this.setState({ discountValue: targetValue });
  }

  render() {
    const discountApplied = this.state.discountValue.toLowerCase() === DISCOUNT_CODE;
    const ticketTypes = [
      {id: 'type-1', label: 'Speaker'}, 
      {id: 'type-2', label: 'Attendee'},
      {id: 'type-3', label: 'Coordinator'},
      {id: 'type-4', label: 'Volunteer'}
    ];

    return (
      <BrowserContainer label={`Register for ${CONFERENCE_NAME}`}>
        <section>
          <img src='assets/images/emailBanner.png' alt={EMAIL_BANNER} />
          <div className='mal pam slds-box bg-white'>
            <h2 className='f3'>{`Registration for ${CONFERENCE_NAME}`}</h2>
            <section className='mtl slds-grid'>
              <Input 
                className='prl slds-col slds-size_1-of-2'
                id='first-name' 
                label='First Name' 
                value='Codey' />
              <Input 
                className='prl slds-col slds-size_1-of-2'
                id='last-name' 
                label='Last Name' 
                value='Bear' />
            </section>
            <section className='mtl slds-grid'>
              <Input 
                className='prl slds-col slds-size_1-of-2'
                id='email' 
                label='Email' 
                value='codey.bear@salesforce.com' />
              <Combobox
                id='ticket-type'
                classNameContainer='prl wi-full'
                events={{
						      onSelect: (event, data) => {
                    console.log('onSelect', event, data);
						      	this.setState({
						      		ticketTypeValue: '',
						      		ticketTypeSelection: data.selection,
						      	});
						      }
					      }}
                labels={{
                  label: 'Attendee Type',
                  placeholder: 'Select Type',
                }}
                selection={this.state.ticketTypeSelection}
                options={ticketTypes}
                variant='readonly'
                value={this.state.ticketTypeValue}
              />
            </section>
            <section className='mtl slds-grid slds-form-element'>
              <div className='prl slds-col slds-size_1-of-2'>
                <label className='slds-form-element__label' htmlFor='discountCode'>
                  Discount Code
                </label>
                <div className='slds-form-element__control'>
                  <input 
                    id='discountCode' 
                    className={classNames('slds-input', {
                      'error-animation border-error': this.state.hasDiscountError
                    })} 
                    aria-describedby='discount-code-error'
                    onChange={this.handleDiscountOnChange}
                    ref={this.discountField}
                    type='text' 
                    value={this.state.discountValue} 
                  />
                </div>
                <div className={classNames('slds-form-element__help text-error', {
                  'error-animation': this.state.hasDiscountError, 
                  'opacity-0': !this.state.hasDiscountError
                  })} 
                  id='discount-code-error'
                >
                  Not a valid discount code.
                </div> 
              </div>
              <div className='prl slds-col slds-size_1-of-2'>
                <p className='slds-form-element__label'>Total:</p>
                <p>
                  {discountApplied 
                  ? (<span>
                      <span className='slds-assistive-text'>Old Price:</span>
                      <del>$500</del>
                      <span className='slds-assistive-text'>New Price:</span>
                      <span className='pls f3 bold'>$125</span>
                  </span>)
                  : '$500'
                  }
                </p>
              </div>
            </section>
            <Button
              className='mvl horz-center'
              label='Continue'
              onClick={this.props.nextFunc}
              variant='brand' 
            />
          </div>
        </section>
      </BrowserContainer>
    );
  }
}

export default FormScreen;



// WEBPACK FOOTER //
// ./src/steps/altText/registerScreen.js